// Nome e assinatura do produto em um lugar só. Qualquer tela que precise
// escrever a marca importa daqui — evita a marca antiga sobrevivendo solta
// em algum canto quando o nome mudar de novo.

export const NOME_PRODUTO = 'GLA HiperWaba'

// As duas metades do wordmark: "Hiper" em peso leve, "Waba" em negrito.
export const NOME_PREFIXO = 'Hiper'
export const NOME_SUFIXO = 'Waba'
export const NOME_SELO = 'GLA'

export const ASSINATURA = 'WhatsApp para empresas'

// Crédito do rodapé da tela de entrada.
export const CREDITO_TEXTO = 'Powered by'
export const CREDITO_EMPRESA = 'GLA Solutions Ltda'
export const CREDITO_MARCA_HOSPEDAGEM = 'VolareHost'

// Para onde o crédito leva. Fica aqui porque é uma linha só de troca.
// Atenção: myhs.app é o endereço da própria API e responde JSON — mandar
// cliente para lá mostra código na tela. Se existir um site de apresentação da
// API, é este valor que muda.
export const SITE_EMPRESA = 'https://glasolutions.com.br'
export const SITE_EMPRESA_ROTULO = 'glasolutions.com.br'
